module.exports = require('../manifest.json').version



//////////////////
// WEBPACK FOOTER
// ./node_modules/youboralib/src/version.js
// module id = 112
// module chunks = 0